import { stringToDate } from 'modules/core/lib/dates'

interface Props {
  date: string
  format: 'ui' | 'backend'
}

export const getDaysUntilNextYear = ({ date, format }: Props) => {
  const nextYear = stringToDate(date, format).add(1, 'year').startOf('year')

  const daysUntilNextYear = nextYear.diff(stringToDate(date, format), 'days')

  return daysUntilNextYear
}
